<template>
    <div class="form">
        <Form
            ref="info"
            :model="info"
            :rules="ruleValidate"
            :label-width="100"
            :readonly="isView || isPush"
        >
            <Row :gutter="20">
                <Col span="12">
                    <FormItem label="通知标题" prop="title">
                        <Input
                            v-model="info.title"
                            :maxlength="20"
                            placeholder="最多20个字符"
                            :disabled="loading"
                        >
                        </Input>
                    </FormItem>
                </Col>
                <!-- <Col span="12">
                    <FormItem label="通知类别" prop="notifyType">
                        <Select
                            v-model="info.notifyType"
                            transfer
                            clearable
                            placeholder
                            :disabled="loading"
                        >
                            <Option
                                v-for="(item, index) in publicNotifyTypeList"
                                :value="item.id"
                                :key="index"
                            >
                                {{ item.text }}
                            </Option>
                        </Select>
                    </FormItem>
                </Col> -->
            </Row>
            <Row v-if="isPush" :gutter="20">
                <Col span="24">
                    <FormItem label="发布房间" prop="houseId">
                        <select-tree
                            v-model="info.targetIds"
                            :list="parkList"
                            :readonly="isView"
                            :join-name="joinName"
                            text="title"
                            full-path-name
                            multiple
                        ></select-tree>
                    </FormItem>
                </Col>
            </Row>
            <Row v-if="houseNameAgg" :gutter="20">
                <Col span="24">
                    <FormItem label="发布房间" prop="houseId">
                        <Input
                            v-model="houseNameAgg"
                            type="textarea"
                            :rows="8"
                        ></Input>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="24">
                    <FormItem label="通知内容" prop="content">
                        <Input
                            v-model="info.content"
                            :disabled="loading"
                            :maxlength="180"
                            placeholder="最多180个字符"
                        >
                        </Input>
                    </FormItem>
                </Col>
            </Row>
        </Form>
    </div>
</template>
<script>
import {
    notifyAdd,
    notifyView,
    notifyUpdate,
    pushAdd,
    startPush,
} from '@/api/notify'
import Dict from '_u/dict'
import mForm from '_v/common/m-form'
import mSelectAssetsPark from '_v/common/m-select-assets-park'

export default {
    name: 'iMsgForm',
    mixins: [mForm, mSelectAssetsPark],
    props: {
        id: {
            type: [String, Number],
            default: '',
        },
        // 是否发送
        isPush: {
            type: Boolean,
            default: false,
        },
        // 默认表单数据
        defaultValue: {
            type: Object,
        },
    },
    inject: {
        $modal: {
            default: null,
        },
    },
    data() {
        return {
            info: {
                id: this.id,
                title: '', // 通知标题
                notifyType: '2', // 通知类别
                targetIds: '', // 发布房间
                content: '', // 通知内容
                ver: '', // 版本号
            },
            houseNameAgg: '', // 发布房间,仅显示用
            loading: false,
            dict: {
                publicNotifyType: Dict.NULL,
            },
        }
    },
    computed: {
        ruleValidate() {
            var rules = {
                title: [{ required: true, message: '通知标题必填' }],
                notifyType: [{ required: true, message: '通知类型必填' }],
                content: [{ required: true, message: '通知内容必填' }],
            }
            if (this.isPush) {
                rules.targetIds = [{ required: true, message: '发布房间必填' }]
            }
            return rules
        },
        publicNotifyTypeList() {
            return this.dict.publicNotifyType.val()
        },
    },
    methods: {
        fetch() {
            if (this.id) {
                return notifyView(this.id)
            } else {
                return Promise.resolve({
                    data: {
                        entity: this.defaultValue,
                    },
                })
            }
        },
        // 房间名称拼接
        joinName(node, parent) {
            // 忽略楼层名称
            if (node.level == '3') {
                return parent.title
            } else {
                return parent.title + node.title
            }
        },
    },
    mounted() {
        var $info = this.$refs.info,
            btns = [{ type: 'default', text: '关闭', name: 'cancel' }]

        // 按钮
        if (this.isView === false) {
            btns.unshift({ type: 'primary', text: '确定', name: 'confirm' })
        }
        this.$modal.updateBtns(btns)

        // 预加载
        this.$modal.beforeEnter((next) => {
            Promise.all([
                Dict.get(['public_notify_type']),
                this.fetch(),
                this.isPush ? this.fetchAssetsPark(4) : [],
            ])
                .then((args) => {
                    var [dictGroup, view, parkList] = args

                    Object.keys(this.dict).forEach((name) => {
                        this.dict[name] = dictGroup[name]
                    })

                    if (view) {
                        var viewData = view.data.entity
                        if (viewData) {
                            Object.keys(this.info).forEach(
                                (name) => (this.info[name] = viewData[name])
                            )
                            this.houseNameAgg = viewData.houseNameAgg || ''
                        }
                    }

                    // 房间数据
                    parkList.forEach((v) => {
                        v.id = v.id2
                        v.title = v.name
                        if (v.level == 3) {
                            v.title = v.title.replace('层', '')
                        }
                        if (v.level == 4) {
                            v.spread = true
                        }
                    })
                    this.parkList = parkList
                })
                .finally(() => {
                    next()
                })
        })

        // 确定
        this.$modal.onBtnClick('confirm', (next, options) => {
            $info
                .validate()
                .then(() => {
                    var formData = Object.assign({}, this.info)
                    // 通知
                    if (this.isPush) {
                        return pushAdd({
                            notifyId: this.id,
                            targetIds: this.info.targetIds,
                        }).then((res) => startPush({ pushId: res.data.pushId }))
                    } else {
                        if (this.id) {
                            return notifyUpdate(formData)
                        } else {
                            return notifyAdd(formData)
                        }
                    }
                })
                .then(() => {
                    if (this.isPush) {
                        return this.$Message.success('已发送通知')
                    }
                    if (this.id) {
                        this.$Message.success(this.$t('tips.update.success'))
                    } else {
                        this.$Message.success(this.$t('tips.add.success'))
                    }
                })
                .catch((err) => {
                    options.closeModal = false
                })
                .finally(() => {
                    next()
                })
        })
    },
}
</script>
<style lang="less" scoped></style>
